// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-container small {
  color: #98bcd5;
  font-weight: bold;
}

.inner-container > div {
  margin-bottom: 20px;
}

.title-label {
  margin-top: 5%;
  margin-bottom: 5%;
}
::ng-deep td,
th.mat-header-cell:first-of-type {
  padding-left: 0px !important;
}
::ng-deep th.mat-header-cell {
  padding-right: 10px !important;
}

::ng-deep .mat-elevation-z2 {
  box-shadow: none !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNhcmVwbHVzLW9yZGVyLWRldGFpbC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBYztFQUNkLGlCQUFpQjtBQUNuQjs7QUFFQTtFQUNFLG1CQUFtQjtBQUNyQjs7QUFFQTtFQUNFLGNBQWM7RUFDZCxpQkFBaUI7QUFDbkI7QUFDQTs7RUFFRSw0QkFBNEI7QUFDOUI7QUFDQTtFQUNFLDhCQUE4QjtBQUNoQzs7QUFFQTtFQUNFLDJCQUEyQjtBQUM3QiIsImZpbGUiOiJjYXJlcGx1cy1vcmRlci1kZXRhaWwuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5pbm5lci1jb250YWluZXIgc21hbGwge1xuICBjb2xvcjogIzk4YmNkNTtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG59XG5cbi5pbm5lci1jb250YWluZXIgPiBkaXYge1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xufVxuXG4udGl0bGUtbGFiZWwge1xuICBtYXJnaW4tdG9wOiA1JTtcbiAgbWFyZ2luLWJvdHRvbTogNSU7XG59XG46Om5nLWRlZXAgdGQsXG50aC5tYXQtaGVhZGVyLWNlbGw6Zmlyc3Qtb2YtdHlwZSB7XG4gIHBhZGRpbmctbGVmdDogMHB4ICFpbXBvcnRhbnQ7XG59XG46Om5nLWRlZXAgdGgubWF0LWhlYWRlci1jZWxsIHtcbiAgcGFkZGluZy1yaWdodDogMTBweCAhaW1wb3J0YW50O1xufVxuXG46Om5nLWRlZXAgLm1hdC1lbGV2YXRpb24tejIge1xuICBib3gtc2hhZG93OiBub25lICFpbXBvcnRhbnQ7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-order-detail/careplus-order-detail.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,ggCAAggC","sourcesContent":[".inner-container small {\n  color: #98bcd5;\n  font-weight: bold;\n}\n\n.inner-container > div {\n  margin-bottom: 20px;\n}\n\n.title-label {\n  margin-top: 5%;\n  margin-bottom: 5%;\n}\n::ng-deep td,\nth.mat-header-cell:first-of-type {\n  padding-left: 0px !important;\n}\n::ng-deep th.mat-header-cell {\n  padding-right: 10px !important;\n}\n\n::ng-deep .mat-elevation-z2 {\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
